const CookieManager = { clearAll: () => null };

export { CookieManager };
